import AssetAPI from "../../../api/AssetAPI";
import Asset from '../../../models/asset/Asset';

export default {
  async loadAllAssets({commit}) {
    const response = await new AssetAPI().all();
    const result = [];
    for (let i = 0; i < response.length; i++) {
      result.push(Asset.createFromData(response[i]))
    }
    commit("SET_ALL_ASSETS", result);
  },

  async createAsset({commit}, asset) {
    let response = await new AssetAPI().createAsset(asset);
    commit('ADD_NEW_CREATED_ASSET', response);
    commit("SET_CURRENT_ASSET_ID", response.idInDB);
    return response;
  },

  async updateAsset({ commit }, data) {
    const response = await new AssetAPI().updateAsset(data);
    commit("UPDATE_ASSET", response);
    commit("SET_CURRENT_ASSET_ID", null);
    commit("SET_CURRENT_ASSET_ID", data.idInDB);
  },

  async assetImport({commit}, data) {
    return await new AssetAPI().excelImport(data);
  }
};
